/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { TaskDtoModel } from './task-dto.model';
import { ShipmentGroupSolutionSegmentDefinitionDtoModel } from '@well/delivery-libs/shipment/domain';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';
import { DriverVoModel } from '@well/delivery-libs/driver-management/domain';

export class TaskListWithRouteDTO extends JSONable {

  segmentRouteUuid: string | null = null;
  definition: ShipmentGroupSolutionSegmentDefinitionDtoModel | null = null;
  vehicleVO: VehicleVoModel | null = null;
  licensePlate: string | null = null;
  vehicleType: string | null = null;
  mainDriverVO: DriverVoModel | null = null;
  mainDriverName: string | null = null;
  mainDriverPhoneNumber: string | null = null;
  secondDriverVO: DriverVoModel | null = null;
  secondDriverName: string | null = null;
  instructions: string | null = null;
  taskDTOs: TaskDtoModel[] = [];

}
